<button
  *ngIf="menuActions.length > 1"
  nz-button
  nzGhost
  nzType="primary"
  [nzShape]="buttonStyle"
  nz-dropdown
  [nzDropdownMenu]="menu"
  nzPlacement="bottomRight"
>
  <i *ngIf="icon" nz-icon [nzType]="icon" nzTheme="outline"></i>
  <span *ngIf="title">{{ title }}</span>
</button>
<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu>
    <li
      *ngFor="let item of menuActions"
      nz-menu-item
      (click)="onMenuClick(item)"
    >
      <i
        *ngIf="item.icon"
        nz-icon
        [nzType]="item.icon"
        nzTheme="outline"
        [class.space]="!!item.name"
      ></i>
      <span *ngIf="item.name">{{ item.name | transloco }}</span>
    </li>
  </ul>
</nz-dropdown-menu>

<button
  *ngIf="menuActions.length === 1"
  (click)="onMenuClick(menuActions[0])"
  nz-button
  [nzShape]="buttonStyle"
>
  <i
    *ngIf="menuActions[0].icon"
    nz-icon
    [nzType]="menuActions[0].icon"
    nzTheme="outline"
  ></i>
  <span *ngIf="!menuActions[0].icon">{{
    menuActions[0].name | transloco
  }}</span>
</button>
